import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
    locale: window.localStorage.getItem('pml_lang') || 'en-US',
    fallbackLocale: 'en-US',
    // silentTranslationWarn: true,
    messages: {
        'en-US': require('./en-US.json'),
        'pt-BR': require('./pt-BR.json')
    }
})



// WEBPACK FOOTER //
// ./src/localization/index.js